import React from 'react';
import './common.css';
import logoDefault from '../../assets/images/logo.png';
import { Link, useLocation } from 'react-router-dom';

const domainLogoMap = {
  'airporttaxima.com': 'logoDefault',
  'gobostonloganairport.com': 'https://gobostonloganairport.com/assets/images/logo.png',
  'bostonairportexpresscar.com': 'https://bostonairportexpresscar.com/uploads/logo-favicon-unnamed-178864535-1788884327711.png',
  'bostonairportcheapcar.com': 'https://bostonairportcheapcar.com/assets/images/logo.png',
  'loganairportcar.com': 'https://loganairportcar.com/assets/images/logo.png',
  'bostonloganairportcab.com': 'https://bostonloganairportcab.com/assets/images/logo.png',
  'natickairporttaxi.com': 'https://natickairporttaxi.com/static/media/image1.7ed04203391456d2095e.png',
  'concordairporttaxi.com': 'https://concordairporttaxi.com/static/media/logo.d0dc22d4b1a265454993.png',
  'airportcarlexington.com': 'logoDefault',
  'walthamairporttaxi.com': 'https://walthamairporttaxi.com/assets/image/footer-logo.png',
  'airporttaxiarlington.com': 'https://airporttaxiarlington.com/assets/images/biz-logo.png',
  'airporttaxicambridgema.com': 'https://airporttaxicambridgema.com/assets/images/logo.png',
  'airporttaxiandover.com': 'logoDefault',
  'newtonairporttaxima.com': 'https://newtonairporttaxima.com/assets/images/logo.png',
  'actonairporttaxi.com': 'https://actonairporttaxi.com/assets/images/nav_logo.png',
  'hudsonairporttaxi.com': 'logoDefault',
  'bosairportlimos.com': 'https://bosairportlimos.com/assets/images/biz-logo.png',
  'westonairporttaxima.com': 'https://westonairporttaxima.com/assets/images/hdr-logo.png',
  'wilmingtonairporttaxis.com': 'https://wilmingtonairporttaxis.com/assets/images/logo.png',
  'bostonairportcarma.com': 'https://bostonairportcarma.com/assets/images/logo.png',
  'bostonairporttaxis.com': 'https://bostonairporttaxis.com/assets/image/logo.png',
  'gologanairport.com': 'https://dispatch.gologanairport.com/assets/images/logo-sm.png',
  'gobostonairport.com': 'https://gobostonairport.com/assets/images/logo.png',
  'worcesterairporttaxi.com': 'https://worcesterairporttaxi.com/images/Logo%20Blue.png',
  'loganexpresscar.com': 'https://loganexpresscar.com/assets/images/logo.svg',
  'localhost': logoDefault,
  'booking-square-int.vercel.app': logoDefault,
};

function getCurrentDomain() {
  const host = window.location.hostname;
  if (host === 'localhost' || host.endsWith('.vercel.app')) {
    return host;
  }
  const parts = host.split('.');
  if (parts.length >= 3) {
    return parts.slice(1).join('.');
  }
  return host;
}

const Navbar = () => {
  const currentDomain = getCurrentDomain();
  const logoSrc = domainLogoMap[currentDomain] || logoDefault;
  const location = useLocation();

  // Progression map
  const getStep = () => {
    if (location.pathname === '/' || location.pathname === '') return 1;
    if (location.pathname.includes('quote') || location.pathname.includes('vehicleselection')) return 2;
    if (location.pathname.includes('vehicleextra') || location.pathname.includes('payment')) return 3;
    if (location.pathname.includes('order-complete')) return 4;
    return 1;
  };

  const currentStep = getStep();

  return (
    <header className="sticky top-0 z-50 w-full bg-[#0b132b]/95 backdrop-blur-xl border-b border-slate-700/50 shadow-md">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 lg:px-8 h-20">
        {/* Brand Logo Only - Bigger, No Border */}
        <Link to="/" className="flex items-center group py-2">
          <img 
            src={logoSrc} 
            alt='Logo' 
            className="h-12 sm:h-14 w-auto max-w-[220px] sm:max-w-[280px] object-contain filter drop-shadow transition-transform duration-200 group-hover:scale-105" 
          />
        </Link>

        {/* Corporate Progress Indicator */}
        <div className="hidden lg:flex items-center gap-6">
          <div className="flex items-center gap-2.5">
            <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all ${currentStep >= 1 ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/30 ring-2 ring-blue-400/40' : 'bg-slate-800 text-slate-400'}`}>
              1
            </div>
            <span className={`text-xs font-semibold ${currentStep >= 1 ? 'text-white' : 'text-slate-500'}`}>Trip Details</span>
          </div>
          <div className={`w-8 h-[2px] rounded ${currentStep >= 2 ? 'bg-blue-500' : 'bg-slate-800'}`} />

          <div className="flex items-center gap-2.5">
            <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all ${currentStep >= 2 ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/30 ring-2 ring-blue-400/40' : 'bg-slate-800 text-slate-400'}`}>
              2
            </div>
            <span className={`text-xs font-semibold ${currentStep >= 2 ? 'text-white' : 'text-slate-500'}`}>Vehicle Class</span>
          </div>
          <div className={`w-8 h-[2px] rounded ${currentStep >= 3 ? 'bg-blue-500' : 'bg-slate-800'}`} />

          <div className="flex items-center gap-2.5">
            <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all ${currentStep >= 3 ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/30 ring-2 ring-blue-400/40' : 'bg-slate-800 text-slate-400'}`}>
              3
            </div>
            <span className={`text-xs font-semibold ${currentStep >= 3 ? 'text-white' : 'text-slate-500'}`}>Passenger & Payment</span>
          </div>
        </div>

        {/* 24/7 Corporate Dispatch Line & New Reservation Action */}
        <div className="flex items-center gap-4">
          <a
            href="tel:6174997770"
            className="hidden sm:flex items-center gap-2.5 px-3.5 py-2 rounded-xl bg-slate-900/90 border border-slate-700/60 hover:border-blue-400/50 transition-all text-xs text-slate-200 shadow-sm"
          >
            <span className="flex h-2 w-2 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            <span className="font-semibold text-slate-300">24/7 Dispatch:</span>
            <span className="font-mono text-blue-300 font-bold">(617) 499-7770</span>
          </a>

          <Link
            to="/"
            className="exec-btn-primary px-4 sm:px-5 py-2.5 rounded-xl text-xs font-bold uppercase tracking-wider flex items-center gap-1.5 shadow-md"
          >
            <span className="material-symbols-outlined !text-base">add_circle</span>
            New Booking
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
